module.exports = {"year":{"one":"{0} Jahr","other":"{0} Jahre"},"month":{"one":"{0} Monat","other":"{0} Monate"},"week":{"one":"{0} Woche","other":"{0} Wochen"},"day":{"one":"{0} Tag","other":"{0} Tage"},"hour":{"one":"{0} Stunde","other":"{0} Stunden"},"minute":{"one":"{0} Minute","other":"{0} Minuten"},"second":{"one":"{0} Sekunde","other":"{0} Sekunden"},"now":{"future":"in einem Moment","past":"gerade jetzt"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/locale-more-styles/de/long-time.json
// module id = 611
// module chunks = 0